import axiosIns from '@/api/axios'

export const LOGOUT = (args) => {
    return axiosIns.post(`${process.env.VUE_APP_KEYCLOAK_URL}/realms/${process.env.VUE_APP_KEYCLOAK_REALMS}/protocol/openid-connect/logout`, args, {
        headers: {
            "ngrok-skip-browser-warning": false,
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}